import { render, staticRenderFns } from "./PageInstruct.vue?vue&type=template&id=dafb9832&scoped=true&"
import script from "./PageInstruct.vue?vue&type=script&lang=js&"
export * from "./PageInstruct.vue?vue&type=script&lang=js&"
import style0 from "./PageInstruct.vue?vue&type=style&index=0&id=dafb9832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafb9832",
  null
  
)

export default component.exports